export default __webpack_public_path__ + "static/media/0x5f1657896b38c4761dbc5484473c7a7c845910b6.19cf1eb9.svg";